import { styled } from '@creditas/stylitas'
import { Table } from '@creditas/table'

const CustomTable = styled(Table)`
  border: 1px solid #eee;
  width: 100%;
`

export { CustomTable as Table }
